module.exports = __webpack_public_path__ + "04_medium_gold.e4d5025f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_medium_gold.png
// module id = tVmE
// module chunks = 0